import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDataFetcher } from '../../../hooks';
import { Container } from 'react-bootstrap';
import { FormHeading } from '../../../form/formHeading';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import ErrorList from '../../../errorList';
import { Form, Well } from '../../../form';
import { IEditQuestionnaireBuilderPageRouteParams } from './types';
import QuestionnaireForm from '../form';
import updateQuestionnaire from './updateQuestionnaire';
import deleteQuestionnaire from './deleteQuestionnaire';
import schema from '../form/schema';
import {
  ConfirmationModal,
  ConfirmationModalPropsFactory,
  useModal,
} from '../../../modals';

export const EditQuestionnairePage: React.FC = () => {
  const history = useHistory();
  const { showModal, hideModal } = useModal();

  const { id } = useParams<IEditQuestionnaireBuilderPageRouteParams>();

  const [deleteErrors, setDeleteErrors] = useState<Array<string>>([]);

  const {
    busy,
    errors: fetchErrors,
    data: questionnaire,
  } = useDataFetcher(`api/questionnaires/${id}`);

  const handleDelete = () => {
    const confirmationProps =
      ConfirmationModalPropsFactory.CreateDeleteEntityConfirmationModal(
        'Questionnaire',
        +id,
        deleteQuestionnaire,
        showModal,
        hideModal,
        setDeleteErrors,
        () => history.replace('/admin/questionnaires'),
      );

    showModal(ConfirmationModal, confirmationProps);
  };

  return (
    <Container fluid>
      <Well>
        <FormHeading
          title="Questionnaire"
          subTitle="Edit"
          backPath="/admin/questionnaires"
        />
        <AjaxErrorBoundary
          busy={busy}
          loadingText={`Loading questionnaire`}
          errors={fetchErrors}
        >
          <ErrorList errors={deleteErrors} />
          <Form
            initialValues={questionnaire}
            promise={updateQuestionnaire}
            validationSchema={schema}
            onSubmit={() => history.push('/admin/questionnaires')}
          >
            <QuestionnaireForm onDelete={handleDelete} />
          </Form>
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};
